export default "__VITE_ASSET__QFefcZX9__"